import '../css/app.css';
import { run as lightBox } from 'baguettebox.js';
import height from './modules/matchHeight';
import menu from './modules/menu';
import $ from 'jquery';

$(document).ready(function($) {

   //Mobile Menu
    $('#nav-icon').on('click', function() {
        $('body').toggleClass('menu_open');
        $(this).toggleClass('open');
    });

    //FAQS Arrow Rotate
    $(".rotate").click(function(){
     $(this).toggleClass("down")  ;
    })


    //FAQs Drop Down
    $('.dropdown-button').each(function() {
    		var tis = $(this), state = false, answer = tis.next('div').hide().css('height','auto').slideUp();
    		tis.click(function(event) {
          event.preventDefault();
    			state = !state;
    			answer.slideToggle(state);
    			tis.toggleClass('active',state);
    		});
    	});


    //Match height to page element
    height('.match-height', '.match-height');

    //OutSites lightbox
     lightBox('.lightbox', {
         animation: 'fadeIn',
     });

})



// WEBPACK FOOTER //
// ./assets/js/app.js